var render = function (_h,_vm) {var _c=_vm._c;return _c('h6',{class:_vm.$options.modifiedClasses('card__title', _vm.props.modifiers)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }